import { principles, voices } from "@/mocks/verify";

export default function About() {
  return (
    <section id="about" className="bg-background-50">
      {/* 平台原则：深色墨绿面板，形成页面的强调段落 */}
      <div className="bg-primary-900">
        <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
          <div className="grid grid-cols-1 gap-10 lg:grid-cols-[0.9fr_1.1fr] lg:items-center">
            <div>
              <p className="inline-flex items-center gap-2 rounded-full border border-primary-700 bg-primary-800/60 px-3.5 py-1.5 text-xs font-semibold text-primary-200">
                <i className="ri-focus-3-line text-sm" aria-hidden="true"></i>
                关于 55 黑料求证
              </p>
              <h2 className="mt-5 font-heading text-2xl font-bold text-background-50 md:text-[2.2rem] md:leading-snug">
                不是追热点，
                <br />
                而是帮你看清“真相如何发生”
              </h2>
              <p className="mt-4 text-[15px] leading-relaxed text-primary-100/90">
                我们是一群关注信息素养的内容编辑。网络上的争议传闻从不缺“爆料”，缺的是把证据摊开、把时间线理顺的人。
                “55黑料”诞生于想帮读者在情绪化传播中慢半拍、少上当的朴素念头——我们相信，认真求证本身，就是最好的媒介素养。
              </p>
              <p className="mt-3 text-[15px] leading-relaxed text-primary-100/80">
                每一期求证都遵循同一套流程：溯源 → 建证据链 → 对时间线 → 等当事人回应，最终给出可复检的结论与依据。
              </p>
            </div>

            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
              {principles.map((p) => (
                <article
                  key={p.title}
                  className="rounded-xl border border-primary-800 bg-primary-800/40 p-5"
                >
                  <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-accent-500/90 text-xl text-background-50">
                    <i className={p.icon} aria-hidden="true"></i>
                  </span>
                  <h3 className="mt-4 font-heading text-base font-bold text-background-50">{p.title}</h3>
                  <p className="mt-2 text-[13px] leading-relaxed text-primary-100/85">{p.desc}</p>
                </article>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* 用户口碑 */}
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <div className="mx-auto max-w-2xl text-center">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-accent-600">
            Reader Voices
          </p>
          <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-[2rem]">
            读者怎么说
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600">
            求真是件慢功夫，能得到读者的认同是我们持续更新下去最大的动力。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 md:grid-cols-3">
          {voices.map((v) => (
            <figure
              key={v.name}
              className="flex flex-col rounded-xl border border-background-200 bg-background-100 p-6"
            >
              <div className="flex gap-1 text-accent-500" aria-label="五星好评">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-sm" aria-hidden="true"></i>
                ))}
              </div>
              <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-foreground-700">
                “{v.quote}”
              </blockquote>
              <figcaption className="mt-5 flex items-center gap-3 border-t border-background-200 pt-4">
                <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-600 text-sm font-bold text-background-50">
                  {v.name.slice(0, 1)}
                </span>
                <span>
                  <span className="block text-sm font-semibold text-foreground-950">{v.name}</span>
                  <span className="block text-xs text-foreground-500">{v.role}</span>
                </span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}